import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-subtitle-1" }
const _hoisted_2 = { class: "ml-4" }
const _hoisted_3 = { class: "text-subtitle-1 text-primary font-weight-bold" }
const _hoisted_4 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_5 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_6 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_7 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "text-center"
}
const _hoisted_11 = { key: 1 }

import { ref } from "vue";
import SavingDetailViewModel from "@/viewmodels/app/SavingDetailViewModel";
import TransferDialog from "@/components/dialogs/TransferDialog.vue";
import StateOfAccountDialog from "@/components/dialogs/StateOfAccountDialog.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SavingDetailComponent',
  setup(__props) {

const transferDialogRef = ref(null);

const stateOfAccountDialogRef = ref(null);
const viewModel = new SavingDetailViewModel(
  transferDialogRef,
  stateOfAccountDialogRef
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_breadcrumbs, {
              class: "text-caption py-0 px-0",
              items: _unref(viewModel).breadcrumbs
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-chart-bar",
                  size: "small"
                })
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, { style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, { class: "rounded-sm pa-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, {
                      class: "text-subtitle-1 font-weight-bold",
                      style: {"white-space":"normal"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(viewModel).saving.value?.TIPO_AHORRO), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_1, [
                          _cache[1] || (_cache[1] = _createElementVNode("strong", null, "ID de Ahorro: ", -1)),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(viewModel).saving.value?.idahorro), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, { style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, { class: "rounded-sm pa-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode(" Ahorro Disponible ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).saving.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(_unref(viewModel).saving.value?.saldo)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-4 rounded-sm",
              flat: "",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Detalle de Ahorro ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_container, {
                  fluid: "",
                  class: "px-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createElementVNode("span", { class: "text-subtitle-1" }, "TREA", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(viewModel).formatFloat(_unref(viewModel).saving.value?.tea)) + "% ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createElementVNode("span", { class: "text-subtitle-1" }, "Plazo", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(viewModel).saving.value?.plazo) + " días ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createElementVNode("span", { class: "text-subtitle-1" }, "Fecha de Apertura", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(viewModel).formatDate(_unref(viewModel).saving.value?.fechaapertura)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createElementVNode("span", { class: "text-subtitle-1" }, "Fecha de Vencimiento", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, [
                              (!_unref(viewModel).saving.value?.fechavencimiento)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "---"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(viewModel).formatDate(_unref(viewModel).saving.value?.fechavencimiento)), 1))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-4 rounded-sm",
              flat: "",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" Movimientos ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                (_unref(viewModel).loadingMovements.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary",
                        size: "30"
                      }),
                      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-caption mt-2" }, "Cargando movimientos...", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_unref(viewModel).movements.value.length === 0)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "info",
                            class: "text-center text-subtitle-2",
                            variant: "tonal",
                            text: "Actualmente no tienes movimientos.",
                            border: ""
                          }))
                        : (_openBlock(), _createBlock(_component_v_list, {
                            key: 1,
                            class: "overflow-y-auto",
                            "max-height": "215"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).movements.value, (mov, idx) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 'mov-' + idx,
                                  class: "pa-4 mb-2",
                                  border: "",
                                  style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_avatar, {
                                      rounded: "lg",
                                      size: "48",
                                      variant: "tonal",
                                      color: _unref(viewModel).getColor(mov.tipomov)
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "20" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(viewModel).getIconName(mov.tipomov)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold text-truncate pr-10" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(mov.concepto), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-2" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(viewModel).formatDate(mov.fecharegistro)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  append: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["text-subtitle-1 font-weight-bold", `text-${_unref(viewModel).getColor(mov.tipomov)}`])
                                    }, _toDisplayString(_unref(viewModel).formatCoin(_unref(viewModel).saving.value?.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(mov.capital)), 3)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }))
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      justify: "center",
      align: "stretch"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6",
          class: "d-flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-4 rounded-sm flex-grow-1",
              flat: "",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0 text-capitalize" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode(" Transferencia entre cuentas de Ahorro ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_text, { class: "px-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_alert, {
                      type: "info",
                      variant: "tonal",
                      border: "start",
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" La transferencia será revisada y validada antes de ser procesada. ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      block: "",
                      flat: "",
                      variant: "tonal",
                      class: "text-none",
                      loading: _unref(viewModel).loadingTransfer.value,
                      onClick: _unref(viewModel).solicitarTransferencia
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode(" Solicitar Transferencia ")
                      ])),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6",
          class: "d-flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "pa-4 rounded-sm flex-grow-1",
              flat: "",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode(" Estado de Cuenta ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_text, { class: "px-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _unref(viewModel).selectedDate.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(viewModel).selectedDate.value) = $event)),
                      items: _unref(viewModel).availableDates.value,
                      label: "Seleccione un Mes y Año",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      "item-title": "label",
                      "item-value": "value"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "secondary",
                  block: "",
                  flat: "",
                  class: "text-none",
                  loading: _unref(viewModel).loadingEstadoCuenta.value,
                  onClick: _unref(viewModel).getStateOfAccount,
                  disabled: !_unref(viewModel).selectedDate
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode(" Ver Estado de Cuenta ")
                  ])),
                  _: 1
                }, 8, ["loading", "onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(TransferDialog, {
      ref_key: "transferDialogRef",
      ref: transferDialogRef
    }, null, 512),
    _createVNode(StateOfAccountDialog, {
      ref_key: "stateOfAccountDialogRef",
      ref: stateOfAccountDialogRef
    }, null, 512)
  ], 64))
}
}

})